import { Modal, Button } from "antd";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";

interface DonateSuccessModalProps {
  open: boolean;
  onClose: () => void;
  onViewRecord: () => void;
  onContinue: () => void;
}

const DonateSuccessModal = ({ open, onClose, onViewRecord, onContinue }: DonateSuccessModalProps) => {
  const { t } = useTranslation();
  const { isMobile } = useAppSelector((state: RootState) => state.app);

  return (
    <Modal open={open} footer={null} centered closable onCancel={onClose} className="donate-success-modal">
      <div className="flex flex-col items-center justify-center p-5 text-center">
        <Image src="/images/csr/success-icon.webp" alt="donation" width={48} height={48} />
        <h2 className="mt-6 text-xl font-semibold">{t("csr.donation_success")}</h2>
        <p className={`my-4 text-[#1c1c1c] ${isMobile ? "w-3/5" : ""}`}>{t("csr.donation_success_tip")}</p>
        <div className="flex justify-center gap-4 text-sm">
          <Button type="default" onClick={onContinue} className="bg-white" size="large">
            {t("csr.continue_event")}
          </Button>
          <Button type="primary" onClick={onViewRecord} size="large">
            {t("csr.view_donation_record")}
          </Button>
        </div>
        <style jsx global>{`
          .donate-success-modal .ant-modal-content {
            padding: 0 !important;
            margin: 8px 16px;
          }
        `}</style>
      </div>
    </Modal>
  );
};

export default DonateSuccessModal;
